<template>
  <base-modal
      icon="label"
      title="Edit Tag">
    <div class="container">
      <div
          class="icon"
          :style="{ color: tag.color }">
        {{ tag.icon }}
      </div>
      <div class="properties-container">
        <label>
          <span>Color</span>
          <base-color-input v-model="tag.color"/>
        </label>
        <label>
          <span>Icon</span>
          <base-input
              v-model="tag.icon"
              type="text"/>
        </label>
      </div>
    </div>
    <template #footer>
      <base-button
          text="Cancel"
          @click="cancel"/>
      <base-button
          text="Save"
          @click="save"/>
    </template>
  </base-modal>
</template>

<script>
import BaseButton from '@/components/core/BaseButton.vue';
import BaseColorInput from '@/components/core/BaseColorInput.vue';
import BaseInput from '@/components/core/BaseInput.vue';
import BaseModal from '@/components/core/modal/BaseModal.vue';

export default {
  name: 'TagEditModal',
  components: {
    BaseButton,
    BaseColorInput,
    BaseInput,
    BaseModal,
  },
  props: {
    tagName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tag: {},
    };
  },
  async created() {
    const tag = await this.$store.dispatch(
      'tags/getTag',
      { name: this.tagName },
    );
    this.tag = tag;
  },
  methods: {
    cancel() {
      this.$modal.dismiss();
    },
    async save() {
      await this.$store.dispatch(
        'tags/updateTag',
        { tag: this.tag },
      );
      this.$modal.dismiss();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.container {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0.625rem;
  width: 22rem;

  .icon {
    $icon-size: 6rem;

    align-self: center;
    font-size: $icon-size;
    height: $icon-size;
    line-height: $icon-size;
    margin-bottom: 1rem;
    width: $icon-size;
  }

  .properties-container {
    border-radius: 0.5rem;
    background: $dark-gray-900;
    display: flex;
    flex-direction: column;

    label {
      align-items: center;
      display: flex;
      justify-content: space-between;
      padding: 0.5rem;

      &:not(:last-child) {
        border-bottom: 0.0625rem solid $dark-gray-700;
      }

      span {
        margin: 0 0.5rem;
      }

      input[type="text"] {
        width: 10rem;
      }
    }
  }
}
</style>
